export const googleAnalytics = (item) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(item);
    return true;
}

export const googleAnalyticsProductConfigurator = (fieldName, value, productId) => {
    googleAnalytics({
        event: 'productConfigurator',
        fieldName,
        value,
        productId,
    })
}

export const googleAnalyticsAddToCart = (products) => {
    if (!Array.isArray(products) || products.length === 0) {
        return;
    }
    const formattedProducts = products.map(({ name, id, category, campaignProduct }) => ({
        name,
        id,
        category,
        campaignProduct,
    }));

    googleAnalytics({
        event: "addToCart",
        ecommerce: {
            add: {
                products: formattedProducts,
            },
        },
    });
}


